import FavoriteIcon from '@mui/icons-material/Favorite';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import RadioIcon from '@mui/icons-material/Radio';
import TodayIcon from '@mui/icons-material/Today';
import { Chip, ChipProps } from '@mui/material';
import { Countdown } from 'components/common/Countdown';
import dayjs from 'dayjs';
import { EventOccasion } from 'models/EventOccasion';
import { useTranslation } from 'react-i18next';

export enum EventChipType {
  Date,
  ExpireDate,
  RequestCount,
  Live,
}

export interface EventChipProps extends ChipProps {
  type: EventChipType;
  event?: EventOccasion;
}

export function EventChip(props: EventChipProps) {
  const { t } = useTranslation()
  const { type, event, ...rest } = props;
  const requestsExpired = dayjs().isAfter(dayjs(event?.expireDate));
  const requestsClosed = event?.disableRequests;
  const hasInteraction = props.onClick === undefined;

  switch (type) {
    case EventChipType.Date:
      return (
        <Chip
          icon={<TodayIcon />}
          color="primary"
          label={dayjs(event?.date).format('ll')}
          {...rest}
        />
      );
    case EventChipType.ExpireDate:
      return (
        <Chip
          icon={<FavoriteIcon />}
          color={requestsClosed || requestsExpired ? 'error' : 'default'}
          deleteIcon={
            props.onDelete ? requestsClosed ? <PlayCircleIcon /> : <PauseCircleIcon /> : undefined
          }
          label={
            requestsClosed ? (
              'Requests disabled'
            ) : requestsExpired ? (
              t('requestDateExpired', 'Request date expired')
            ) : (
              <Countdown targetDate={event?.expireDate} />
            )
          }
          {...rest}
        />
      );
    case EventChipType.RequestCount:
      return (
        <Chip
          icon={<MusicNoteIcon />}
          color="default"
          label={t('valRequests', '{{val}} Requests', { val: event?.requests?.length })}
          {...rest}
        />
      );
    case EventChipType.Live:
      if (!event?.isLiveEvent) return <></>;
      return (
        <Chip
          icon={<RadioIcon />}
          color="error"
          label={t('liveEvent', 'Live Event')}
          {...rest}
        />
      );
    default:
      return <></>;
  }
}
